import { fetchTableElementData } from "../../helpers/data-catalogue-api"
import { UpdateDataDictionaryTable } from "./data-dictionary-table"
import { UpdateDataDictionaryMobileCard } from "./data-dictionary-mobile-card"
import { updatePagination } from "./pagination"

export async function InitDataDictionarySelector() {
    const dataDictionarySelector = document.getElementById("dataDictionarySelector")
    if (!dataDictionarySelector) return

    dataDictionarySelector.addEventListener("change", async function () {
        const params = new URLSearchParams(window.location.search)
        const catalogueId = params.get("id")
        const originId = params.get("originId")

        if (!catalogueId || !originId) {
            console.error("Missing catalogue ID or origin ID in URL parameters")
            return
        }

        try {
            const tableData = await fetchTableElementData(catalogueId, this.value, originId, 1)
            await UpdateDataDictionaryTable(tableData.result)
            await UpdateDataDictionaryMobileCard(tableData.result)
            await updatePagination(tableData)
            updateTableDescription(tableData.result)
        } catch (error) {
            console.error("Error fetching data dictionary table:", error)
        }
    })
}

function updateTableDescription(tableData) {
    const descriptionContainer = document.getElementById("dataDictionaryTableDescription")
    if (!descriptionContainer) return
    descriptionContainer.innerText = tableData.description || ""
}
